import { useState } from 'react';
import TourReportFeed from './TourReportFeed';
import TourReportSheet from './TourReportSheet';

/** Self-contained tour-rollup feed + slide-over, registered as an operation component. */
export default function TourReportOperation({ soulId }: { soulId: string }) {
  const [openReportId, setOpenReportId] = useState<string | null>(null);
  return (
    <>
      <TourReportFeed soulId={soulId} onOpenReport={setOpenReportId} />
      <TourReportSheet
        reportId={openReportId}
        open={!!openReportId}
        onOpenChange={(o) => !o && setOpenReportId(null)}
      />
    </>
  );
}
